import { ReactNode } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { CoreIconButton, CoreIconButtonProps } from "./Button";
import CaretUp from "../../images/caret-up.svg?react";
import CaretSmall from "../images/caret-small.svg?react";

export type CoreExpandButtonProps = Omit<CoreIconButtonProps, "tooltip" | "onClick" | "onChange" | "children"> & {
	collapsedRight?: boolean;
	expanded: boolean;
	onChange: (newExpanded: boolean) => void;
	collapsedTooltip?: ReactNode;
	expandedTooltip?: ReactNode;
	iconSize?: CoreExpandIconProps["size"];
	iconColor?: CoreExpandIconProps["color"];
	iconVariant?: CoreExpandIconProps["variant"];
	slotProps?: {
		icon?: Omit<SvgIconProps, "children" | "color">;
	};
};

export default function CoreExpandButton({
	variant,
	collapsedRight = false,
	expanded,
	onChange,
	collapsedTooltip,
	expandedTooltip,
	iconColor = "#4d4d4d",
	iconSize = 18,
	iconVariant,
	slotProps,
	...buttonProps
}: CoreExpandButtonProps) {
	return (
		<CoreIconButton
			{...({ variant, color: variant === "plain" ? "#4D4D4D" : undefined, ...buttonProps } as CoreIconButtonProps)}
			onClick={() => onChange(!expanded)}
			tooltip={expanded ? expandedTooltip : collapsedTooltip}
			aria-expanded={expanded}
		>
			<CoreExpandIcon
				expanded={expanded}
				collapsedRight={collapsedRight}
				color={iconColor}
				size={iconSize}
				variant={iconVariant}
				{...slotProps?.icon}
			/>
		</CoreIconButton>
	);
}

type CoreExpandIconProps = {
	collapsedRight?: boolean;
	expanded: boolean;
	size?: number;
	color?: string;
	// There are 2 types of arrows now??
	variant?: "wide" | "narrow";
} & Omit<SvgIconProps, "children" | "color">;

export function CoreExpandIcon({
	collapsedRight = false,
	expanded,
	size = 18,
	color = "#6f6f6f",
	variant = "wide",
	...props
}: CoreExpandIconProps) {
	const icon: ReactNode = variant === "wide" ? <CaretUp /> : <CaretSmall />;

	return (
		<SvgIcon
			{...props}
			sx={{
				fontSize: size,
				color,
				transform: expanded ? "rotate(0deg)" : collapsedRight ? "rotate(90deg)" : "rotate(180deg)",
				...props.sx,
			}}
		>
			{icon}
		</SvgIcon>
	);
}
